import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import StoreCard from "./StoreCard";
import Skeleton from "./Skeleton";
import "./clientTheme.css";
import "./StoreShelf.css";

export default function StoreShelf({ title, stores, loading, viewAllHref }) {
  const { t } = useTranslation("common");
  if (loading) {
    return (
      <section className="store-shelf">
        <div className="store-shelf-header">
          <h2 className="store-shelf-title">{title}</h2>
        </div>
        <div className="store-shelf-row">
          {Array.from({ length: 4 }).map((_, index) => (
            <div className="store-shelf-item" key={index}>
              <Skeleton className="store-shelf-skeleton-card" />
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (!stores || stores.length === 0) return null;

  return (
    <section className="store-shelf">
      <div className="store-shelf-header">
        <h2 className="store-shelf-title">{title}</h2>
        {viewAllHref && (
          <Link to={viewAllHref} className="store-shelf-view-all">
            {t("viewAll")} <span aria-hidden="true">→</span>
          </Link>
        )}
      </div>
      <div className="store-shelf-row">
        {stores.map((store) => (
          <div className="store-shelf-item" key={store.storeId}>
            <StoreCard store={store} />
          </div>
        ))}
      </div>
    </section>
  );
}
